import {
  shopifyCustomerGraphQLClient,
  shopifyStorefrontGraphQLClient,
} from 'lib/shopify';

import { getSdk as storefrontSdk } from './generated';
import { getSdk as customerSdk } from './generated.customer';

export const ShopifyService = storefrontSdk(shopifyStorefrontGraphQLClient);
export const ShopifyCustomerService = customerSdk(shopifyCustomerGraphQLClient);

export * from './generated';
export {
  type CustomerOrdersQuery,
  type GetCustomerQuery,
} from './generated.customer';
